module.exports = __webpack_public_path__ + "static/img/14000754.9775ddc5.png";